import { render, staticRenderFns } from "./leadDetails.vue?vue&type=template&id=f1f6eb2c"
import script from "./leadDetails.vue?vue&type=script&lang=js"
export * from "./leadDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports